import { render, staticRenderFns } from "./View-User-File.vue?vue&type=template&id=15d5a728&"
import script from "./View-User-File.vue?vue&type=script&lang=js&"
export * from "./View-User-File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports